import {Injectable} from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import 'rxjs/add/operator/map'
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {User} from 'storyboard-renderer';
import {Router} from "@angular/router";
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class AuthService {
    public token: string;

    constructor(private http: Http, private router: Router) {
        // set token if saved in local storage
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;

        // If there is no roles we need to log the user out to get the new token with roles
        if (currentUser && !currentUser.roles) {
            this.logout();
        }

        // Try to renew the token in every 10 minutes if the remeaning time is after the half of this expiration time.
        setInterval(() => {
            this.renewToken();
        }, 600 * 1000);
    }

    redirectToAuthScreen() {
        window.open(environment.apiBaseUrl + '/api/v1.0/auth/redirect', '_self');
    }

    fakeLogin(email: string, password: string): Observable<boolean> {
        return this.http.post(environment.apiBaseUrl + '/api/v1.0/auth/fake_login', { email: email, password: password })
            .map((response: Response) => {
            // login successful if there's a jwt token in the response
                const token = response.json() && response.json().token;
                if (token) {
                    // set token property
                    this.token = token;

                    const jwtData = this.decodeToken(token);
                    console.log(jwtData)

                    // If the user have no roles we do not authenticate the user
                    if (!jwtData.roles || !jwtData.roles.length) {
                        return false;
                    }

                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser',
                        JSON.stringify({ id: jwtData.sub, email: email, token: token, roles: jwtData.roles }));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    login(code: string): Observable<boolean> {
        return this.http.post(environment.apiBaseUrl + '/api/v1.0/auth/login', {code: code})
            .map((response: Response) => {
                // login successful if there's a jwt token in the response
                const token = response.json() && response.json().token;
                if (token) {
                    // set token property
                    this.setToken(token);

                    const jwtData = this.decodeToken(token);

                    // If the user have no roles we do not authenticate the user
                    if (!jwtData.roles || !jwtData.roles.length) {
                        return false;
                    }

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            });
    }

    logout() {
        const t = this.getCurrentUserToken();
        this.token = null;
        localStorage.removeItem('currentUser');
        if (t) {
            window.location.href = environment.apiBaseUrl + '/api/v1.0/auth/logout?token=' + t;
        } else {
            if (!this.router.url.startsWith('/login')) {
                this.router.navigate(['/login']);
            }
        }

        /*return this.http.post(environment.apiBaseUrl + '/api/v1.0/auth/logout', {})
         .map((response: Response) => {
         // clear token remove user from local storage to log user out
         this.token = null;
         localStorage.removeItem('currentUser');

         return true;
         });*/
    }

    setToken(token) {
        this.token = token;

        const jwtData = this.decodeToken(token);

        // store username and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify({id: jwtData.sub, token: token, roles: jwtData.roles}));
    }

    decodeToken(token) {
        return jwt_decode(token);
    }

    isAuthenticated(): Boolean {
        return !!localStorage.getItem('currentUser');
    }

    hasRole(role: string): boolean {
        if (!this.isAuthenticated() || !this.getCurrentUser().roles) {
            return false;
        }

        return this.getCurrentUser().roles.filter(item => item === role).length !== 0;
    }

    getCurrentUser(): User {
        if (!this.isAuthenticated()) {
            return null;
        }

        return JSON.parse(localStorage.getItem('currentUser'));
    }

    getCurrentUserToken(): string {
        if (!this.isAuthenticated()) {
            return null;
        }
        return this.getCurrentUser().token;
    }

    renewToken() {

        if (!this.isAuthenticated()) {
            return;
        }

        // check token if its half of the ttl we need to renew it
        const jwtData = this.decodeToken(this.getCurrentUserToken());
        const diff = jwtData.exp - jwtData.iat;
        const now = Math.floor(Date.now() / 1000);

        if (jwtData.exp - diff / 2 > now) {
            return;
        }

        this.http.post(environment.apiBaseUrl + '/api/v1.0/auth/token', {'token': this.getCurrentUserToken()})
            .subscribe(result => {
                this.setToken(result.json().token);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts